import ERROR_SPEC from './errorSpec';

const createErrorMessage = (errorSpec, msg) => {
  return { errorSpec, msg };
};

const ERROR_MESSAGE = [
  createErrorMessage(ERROR_SPEC.COMMON.REQUEST_FAIL, '요청을 보내는 데 실패했습니다. '),
  createErrorMessage(
    ERROR_SPEC.COMMON.RESPONSE_FAIL,
    '응답을 받아오는 데 실패했습니다. ',
  ),
  createErrorMessage(ERROR_SPEC.COMMON.INVALID_INPUT, '입력값이 부적절합니다. '),
  createErrorMessage(ERROR_SPEC.COMMON.NEED_INPUT, '입력값이 필요합니다. '),

  createErrorMessage(ERROR_SPEC.HR.NEED_INPUT, '입력값이 필요합니다. '),
];

const getErrorMessage = (spec) => {
  const found = ERROR_MESSAGE.filter((data) => data.errorSpec === spec)[0];
  return found.msg;
};

export default getErrorMessage;
